import React, { FC } from 'react'
import { styled } from '@creditas/stylitas'
import ContentLoader from 'react-content-loader'

const Wrapper = styled.div`
  margin-left: -4px;
`

const ResidenceProofAndIncomeProofContentFetching: FC = () => (
  <Wrapper>
    <ContentLoader height={38}>
      <rect x="0" y="0" rx="8" ry="8" width="240" height="14" />
      <rect x="0" y="22" rx="8" ry="8" width="210" height="14" />
    </ContentLoader>
  </Wrapper>
)

export { ResidenceProofAndIncomeProofContentFetching }
